module.exports = __webpack_public_path__ + "static/fonts/Mont-SemiBoldItalic.6cf32c2.ttf";